module.exports = "./dist/assets/images/icons/2ff69acd9b098d2ab47a5f5e1e05db6b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/nogma.png
// module id = ./assets/images/icons/nogma.png
// module chunks = 0